<template>
  <section class="profile-form">
    <div class="fieldset form-left">
      <profile-avatar :edited="edited"></profile-avatar>
      <h3 class="role">{{$t('profile.statuses.admin')}}</h3>
      <button type="button"
              @click="editProfile"
              v-if="!edited || validCenter"
              class="edit-avatar">
        <edit-icon v-if="!edited"></edit-icon>
        <accept-icon v-else></accept-icon>
      </button>
    </div>
    <div class="profile-wrap">
      <profile-center @formEdit="enableEdit"
                      @disableEdited="disableEdit"
                      :edited="edited"></profile-center>
      <profile-right @formEdit="enableEdit"
                     v-if="authBy != 'google'"
                     :edited="edited"></profile-right>
    </div>
  </section>
</template>

<script>
import {toFormData} from "../../../mixins/utils/toFormData";

  import profileAvatar from './profileAvatar'
  import profileCenter from './profileCenter'
  import profileRight from './profileRight'
  import editIcon from '../../Svg/editIcon'
  import acceptIcon from '../../Svg/acceptIcon'

  import {createNamespacedHelpers} from 'vuex'
  const {mapState} = createNamespacedHelpers('profile');
  const {mapActions} = createNamespacedHelpers('profile');
  const {mapMutations} = createNamespacedHelpers('profile');

  export default {
    name: 'profileForm',
    mixins: [toFormData],
    components: {
      profileAvatar,
      profileCenter,
      profileRight,
      editIcon,
      acceptIcon
    },
    data() {
      return {
        edited: false
      }
    },
    computed: {
      ...mapState([
        'name',
        'surname',
        'mail',
        'tel',
        'city',
        'region',
        'country',
        'language',
        'postalCode',
        'avatar',
        'validCenter',
        'photoUpload',
        'address',
        'authBy'
      ]),
    },
    methods: {
      ...mapActions([
        'updateUser'
      ]),
      ...mapMutations([
        'SET_DIRT'
      ]),
      editProfile() {
        this.edited = !this.edited;
        if (!this.edited) {
          const token = localStorage.getItem('token');

          let data = {
           // access_token: token,
            zip: this.postalCode,
            email: this.mail,
            phone: this.tel ? this.tel : '',
            address: this.address,
            region: this.region,
            city: this.city,
            country: this.country,
            first_name: this.name,
            second_name: this.surname,
            language_id: this.$i18n.locale.toUpperCase()
          };
          let formData = this.toFormData(data);
          formData.append('avatar', this.photoUpload);

          this.updateUser(formData);
          this.SET_DIRT(false)
        }
      },
      enableEdit() {
        this.edited = true
      },
      disableEdit() {
        this.edited = false
      }
    }
  }
</script>

<style lang="scss">
  .profile-form {
    background: white;
    box-shadow: 0px 0px 30px rgba(0, 82, 127, 0.06);
    border-radius: 4px;
    width: 100%;
    padding: 30px 60px 42px 42px;
    display: flex;

    .form-left {
      max-width: 180px - 42px;
      padding-right: 24px;
      position: relative;
    }

    .edit-avatar {
      position: absolute;
      background: white;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08);
      right: 18px;
      top: 100px;
      z-index: 2;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border: 1px solid white;

      &:focus {
        border: 1px solid $lightBlue;
      }
    }

    .role {
      width: 100%;
      height: 30px;
      text-align: center;
      background: $lightBlue;
      border-radius: 100px;
      color: white;
      font-family: $mm;
      font-size: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .legend {
      font-family: $msb, Arial, sans-serif;
      font-size: 14px;
      letter-spacing: 0.25px;
      color: $darkBlue;
      margin-bottom: 45px;
    }

    .fieldset {
      padding-top: 12px;
      text-align: left;
      display: flex;
      flex-direction: column;
    }

    .fieldset-wrap {
      margin-bottom: 48px;
      display: flex;
      flex-direction: column;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .profile-wrap {
      width: calc(100% - 180px + 42px);
      display: flex;
    }
  }
</style>
